<template>
  <Skeleton :class="props.class" />
</template>

<script lang="ts" setup>
import { Skeleton } from '@/components/lib/shadcn-vue/skeleton';

interface Props {
  class?: string;
}

const props = withDefaults(defineProps<Props>(), {
  class: 'w-40 h-6',
});
</script>
